// core
import { ptBR as ptBRCore, enUS as enUSCore } from '@mui/material/locale';
// data-grid
import { ptBR as ptBRDataGrid, enUS as enUSDataGrid } from '@mui/x-data-grid/locales';
// date-pickers
import { ptBR as ptBRDate, enUS as enUSDate } from '@mui/x-date-pickers/locales';
import { ptBR as ptBRAdapter, enUS as enUSAdapter } from 'date-fns/locale';
import merge from 'lodash/merge';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'Português',
    value: 'pt-BR',
    systemValue: merge(ptBRDate, ptBRDataGrid, ptBRCore),
    adapterLocale: ptBRAdapter,
    icon: 'flagpack:pt-BR',
  },
  {
    label: 'English',
    value: 'en',
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: 'flagpack:gb-nir',
  },
];

export const defaultLang = allLangs[0]; // Português

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
